/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

// MBB-代理商资源点-列表
export function listPoints(params) {
    return request({
        url: '/mbb/agent/resource/points/list.do?',
        method: 'post',
        data: params
    })
}

// MBB-代理商资源点-新增
export function savePoints(data) {
    return request({
        url: '/mbb/agent/resource/points/save.do?',
        method: 'post',
        data
    })
}

// MBB-代理商资源点-导出
export function exportPoints(params) {
    return request({
        url: '/mbb/agent/resource/points/export.do?',
        method: 'post',
        data: params
    })
}


